import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import ImportLabelsForm from "./ImportLabelsForm";
import GenerateBatchFromLabels from "./GenerateBatchFromLabels";
import ImportLabelsStore from "store/import-labels-store/importLabelsStore";

const LabelsSteps = (props: any) => {
  const { importLabelsStore, project, ...rest } = props;
  const store = importLabelsStore as ImportLabelsStore;
  const { step } = store;

  useEffect(() => {
    if (project?.id) {
      store.initForProject(project.id);
      if (store.labels.length === 0) {
        store.setLabels(
          project.labelingTypes?.[0]?.listTags?.map((t: any) => t.name) || [],
        );
      }
    }
  }, [project?.id]);

  return (
    <>
      {step === 1 && <ImportLabelsForm project={project} {...rest} />}
      {step === 2 && <GenerateBatchFromLabels project={project} {...rest} />}
    </>
  );
};

export default inject("importLabelsStore")(observer(LabelsSteps));
